<script lang="ts">
  export let href: string = "";
  export let textColor: string = "#F918FF";
  export let hoverTextColor: string = "#C418FF";
  export let disableTextColor: string = "#A7B0B5";
  export let isUnderline: boolean = false;
  export let openInNewTab: boolean = false;
  export let disabled: boolean = false;
</script>

<a
  {href}
  target={openInNewTab ? "_blank" : "_self"}
  class:underline={isUnderline}
  class:disabled
  style="--link-color: {textColor}; --link-hover-color: {hoverTextColor}; --link-disabled-color: {disableTextColor}"
  {...$$restProps}
>
  <slot />
</a>

<style>
  a {
    color: var(--link-color);
  }

  a.underline {
    text-decoration: underline;
  }

  a:not(.underline) {
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
    color: var(--link-hover-color);
  }

  a.disabled {
    pointer-events: none;
    color: var(--link-disabled-color);
  }
</style>
